import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ListItemText from "@material-ui/core/ListItemText";
import Avatar from "@material-ui/core/Avatar";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import ChatIcon from "@material-ui/icons/Chat";
import GroupIcon from "@material-ui/icons/Group";

import { i18n } from "../../translate/i18n";
import getContactDisplayName from "../../helpers/contactDisplayName";

const useStyles = makeStyles(theme => ({
	row: {
		paddingTop: 8,
		paddingBottom: 8,
		borderBottom: "1px solid rgba(0, 0, 0, 0.06)",
		cursor: "pointer",
	},
	avatar: {
		backgroundColor: theme.palette.primary.main,
	},
	groupIcon: {
		marginRight: 4,
		verticalAlign: "middle",
		fontSize: 16,
		color: theme.palette.text.secondary,
	},
}));

const ContactWithoutTicketItem = ({ contact, onStartChat }) => {
	const classes = useStyles();
	// feat_311 — mismo criterio que el resto de la bandeja (TicketListItem /
	// TicketInfo): "Nombre Apellido — Empresa". El helper tolera lastName y
	// organization null, así que un contacto sin esos datos se ve igual que antes.
	const displayName = getContactDisplayName(contact, { fallback: "—" });
	const initial = (displayName[0] || "?").toUpperCase();

	const handleClick = e => {
		e.stopPropagation();
		onStartChat(contact);
	};

	return (
		<ListItem button onClick={handleClick} className={classes.row}>
			<ListItemAvatar>
				<Avatar src={contact.profilePicUrl} className={classes.avatar}>
					{initial}
				</Avatar>
			</ListItemAvatar>
			<ListItemText
				primary={
					<span>
						{contact.isGroup && <GroupIcon className={classes.groupIcon} />}
						{displayName}
					</span>
				}
				secondary={contact.isGroup ? i18n.t("ticketsList.group") : contact.number}
			/>
			<Tooltip title={i18n.t("ticketsList.startChat")}>
				<IconButton edge="end" size="small" onClick={handleClick}>
					<ChatIcon fontSize="small" color="primary" />
				</IconButton>
			</Tooltip>
		</ListItem>
	);
};

export default ContactWithoutTicketItem;
